/* eslint-disable */
const formDefinition = (userProfile) => ({
  ['role-force']: {data: {role: '', force: ''}, errors: []},
  ['personal-details']: {
    data:
      {
        firstName: userProfile?.firstName ?? '',
        lastName: userProfile?.lastName ?? '',
        dateOfBirth: '',
        nationalInsuranceNumber: '',
        phoneNumber: '',
      },
    errors: []
  },
  ['accessibility']: {
    data: {disability: '', disabilityCategory: '', reasonableAdjustment: ''},
    errors: []
  },
  ['nationality-and-race']: {
    data: {
      nationalities: [],
      otherNationalities: [],
      ethnicOrigin: '',
      ethnicOriginParent: '',
    }, errors: []
  },
  ['religion']: {
    data: {
      religiousBelief: '',
    }, errors: []
  },
  ['sex-and-gender']: {data: {sex: '', gender: '', genderOther: '', genderMatch: ''}, errors: []},
  ['sexual-orientation']: {data: {sexualOrientation: ''}, errors: []},
  ['socioeconomic-background']: {
    data: {highSchool: '', parentAcademicAttain: '', freeSchoolMeals: '', fromLowerSocioEcoBackground: ''}
  },
  ['education']: {
    data: {
      academicAttainment: '',
      academicAttainmentParent: '',
      englishAcademicAttainment: '',
      englishAcademicAttainmentParent: ''
    }, errors: []
  },
  ['first-language']: {
    data: {firstLanguageEnglish: '', firstLanguage: '', englishSpeechLevel: ''}
  },
  ['entry-route']: {
    data: {entryRoute: ''}
  },
  ['veteran-status']: {
    data: {militaryVeteran: '', militaryServiceLeaver: ''}
  },
  ['police-roles']: {
    data: {anyPreviousPolicingExperience: '', previousPolicingExperience: [], familyPolicingInvolvement: ''}
  },
  ['verification']: {
    data: {}
  },
  ['candidate-declaration']: {data: {}, errors: []},
  confirmation: {data: {formErrors: {}, completed: false}}
});

export default formDefinition;
